import { getTypographyStyles, SEM_TYPOGRAPHY_FORMS_CAPTION, getMargins, SYS_SPACE_FIXED_50 } from '@oneaudi/unified-web-alpha-common';
import styled from 'styled-components';
import { Badge } from '../badge/index.js';
export const StyledBadge = styled(Badge) `
  flex-shrink: 0;
  padding-top: ${SYS_SPACE_FIXED_50};
`;
export const StyledMessage = styled.span `
  margin: ${(props) => getMargins(props.margin) || 0};
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.variant === 'error'
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
  display: flex;
  gap: ${SYS_SPACE_FIXED_50};
  align-items: flex-start;
  transition-property: color;
  // TODO: token missing;
  transition-duration: 250ms;
  // TODO: token missing;
  transition-timing-function: ease;
`;
//# sourceMappingURL=index.styles.js.map